import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["urlInput", "submitButton", "submitButtonLabel", "submitButtonLoading", "message", "messageText"];

  declare readonly urlInputTarget: HTMLInputElement;
  declare readonly submitButtonTarget: HTMLButtonElement;
  declare readonly submitButtonLabelTarget: HTMLElement;
  declare readonly submitButtonLoadingTarget: HTMLElement;
  declare readonly messageTarget: HTMLElement;
  declare readonly messageTextTarget: HTMLElement;

  connect() {
    this.updateSubmitButtonState();
  }

  onInput() {
    this.updateSubmitButtonState();
  }

  async submit(event: Event) {
    event.preventDefault();

    const url = this.urlInputTarget.value.trim();
    if (!url) return;

    const actionUrl = this.element.dataset.webhookUrlUpdateUrl;
    if (!actionUrl) return;

    this.setLoading(true);
    this.clearMessage();

    try {
      const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "";
      const response = await fetch(actionUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json",
        },
        body: JSON.stringify({ project: { webhook_url: url } }),
      });

      if (response.status === 403) {
        window.location.href = "/403.html";
        return;
      }

      const data = await response.json();

      if (data.success) {
        window.location.href = data.redirect_url;
      } else {
        this.setLoading(false)
        this.showError(data.message);
      }
    } catch {
      this.setLoading(false)
      this.showError("通信エラーが発生しました");
    }
  }

  private updateSubmitButtonState() {
    const url = this.urlInputTarget.value.trim();
    this.submitButtonTarget.disabled = url.length === 0;
  }

  private setLoading(loading: boolean) {
    this.urlInputTarget.disabled = loading;
    this.submitButtonTarget.disabled = loading;
    this.submitButtonLoadingTarget.hidden = !loading;

    this.submitButtonLabelTarget.textContent = loading ? "更新中..." : "更新";

    if (!loading) {
      this.updateSubmitButtonState();
    }
  }

  private clearMessage() {
    this.messageTarget.hidden = true;
    this.messageTextTarget.textContent = "";
  }

  private showError(message: string) {
    this.messageTextTarget.textContent = message;
    this.messageTarget.hidden = false;
  }
}
